import { cn } from "@/lib/utils";

/**
 * CoreBridge Technologies logo mark.
 * Two pillars (cores) connected by an arch (bridge) and deck below.
 * Renders on a gold tile by default; pass `mono` for outline-only on light bg.
 */
export default function Logo({ size = 32, className = "", variant = "tile" }) {
  if (variant === "mark") {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="CoreBridge">
        <path d="M8 12 Q16 4 24 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
        <rect x="6.5" y="11" width="3" height="14" rx="0.5" fill="currentColor"/>
        <rect x="22.5" y="11" width="3" height="14" rx="0.5" fill="currentColor"/>
        <rect x="5" y="22" width="22" height="2" rx="0.5" fill="currentColor"/>
      </svg>
    );
  }
  // Default: gold tile with black bridge mark
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={cn("rounded-md", className)}
      aria-label="CoreBridge Technologies"
    >
      <rect width="32" height="32" rx="6.5" fill="#d4af37"/>
      <path d="M8 13 Q16 5 24 13" stroke="#0a0a0a" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
      <rect x="6.5" y="12" width="3" height="13" rx="0.5" fill="#0a0a0a"/>
      <rect x="22.5" y="12" width="3" height="13" rx="0.5" fill="#0a0a0a"/>
      <rect x="5" y="22.5" width="22" height="2" rx="0.5" fill="#0a0a0a"/>
    </svg>
  );
}

export function LogoWordmark({ size = 32, className = "" }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <Logo size={size}/>
      <div className="leading-none">
        <div className="font-semibold text-sm tracking-tight">CoreBridge</div>
        <div className="text-[9px] text-[var(--text-3)] uppercase tracking-[0.18em] mt-0.5">Technologies</div>
      </div>
    </div>
  );
}
